import {useTranslation} from "react-i18next";
import {memo} from 'react'

import {useCountdownTimer} from "hooks";

const CountDownBlock = ({expirationDate}) => {
    const {countdown} = useCountdownTimer(expirationDate ?? 0, true)
    const {t} = useTranslation()

    if (!countdown.days) return null

    return (` ${countdown.days} ${t("days")} (${countdown.hours}H: ${countdown.minutes}M: ${countdown.seconds}s)`)
}

export default memo(CountDownBlock)